import { Button, Flex, Grid, VisuallyHidden } from "@aws-amplify/ui-react";
import {
  CCard,
  CCardBody,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import {
  Add,
  CameraAlt,
  Close,
  Fullscreen,
  InsertPhoto,
  FlipCameraIos,
} from "@mui/icons-material";
import { useRef, useState } from "react";
import LocalizedStrings from "react-localization";

import "./styles/Gallery.styles.css";
import Webcam from "react-webcam";

const Gallery = ({ title, images, onDelete, onCreate }) => {
  const [modalView, setModalView] = useState({
    visible: false,
  });
  const [facingMode, setFacingMode] = useState("environment");
  const hiddenInput = useRef(null);

  const onOpenTake = () => setModalView({ visible: true });

  const onTake = (src) => {
    onCreate(src);
    setModalView({ visible: false });
  };

  const onSwitch = () =>
    setFacingMode(facingMode === "environment" ? "user" : "environment");

  const onImport = (event) => {
    const { files } = event.target;
    if (!files || files.length === 0) {
      return;
    }
    onCreate(files[0]);
    hiddenInput.current.value = null;
  };

  return (
    <>
      {title && <div className="fs-5">{title}</div>}
      <Flex wrap="wrap" rowGap="30px" columnGap="30px" alignItems="center">
        {images?.map((image) => (
          <div className="image-container">
            <img className="image" src={image.src} alt="gallery-img" />
            <div className="overlay">
              {onDelete && (
                <Close
                  className="close-button"
                  onClick={() => onDelete(image.id)}
                />
              )}
              <Fullscreen
                className="view-button"
                fontSize="large"
                onClick={() => setModalView({ visible: true, src: image.src })}
              />
            </div>
          </div>
        ))}
        {onCreate && (
          <>
            <CDropdown variant="dropdown" placement="right-start">
              <CDropdownToggle
                placement="bottom-end"
                className="border-0 py-0"
                caret={false}
              >
                <CCard className="p-2">
                  <CCardBody style={styles.addBox}>
                    <Add style={styles.addIcon} color="action"></Add>
                  </CCardBody>
                </CCard>
              </CDropdownToggle>
              <CDropdownMenu className="pt-0" placement="bottom-end">
                <CDropdownItem
                  role="button"
                  className="d-inline-flex align-items-center mt-2"
                  onClick={onOpenTake}
                >
                  <Flex gap="5px">
                    <CameraAlt color="action"></CameraAlt>
                    {strings.takePhoto}
                  </Flex>
                </CDropdownItem>
                <CDropdownItem
                  role="button"
                  className="d-inline-flex align-items-center mt-2"
                  onClick={() => hiddenInput.current.click()}
                >
                  <Flex gap="5px">
                    <InsertPhoto color="action"></InsertPhoto>
                    {strings.importPhoto}
                  </Flex>
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
            <VisuallyHidden>
              <input
                type="file"
                tabIndex={-1}
                ref={hiddenInput}
                onChange={onImport}
                accept="image/*"
              />
            </VisuallyHidden>
          </>
        )}
      </Flex>
      {modalView.visible && (
        <CModal
          portal={false}
          className="modal-full"
          visible={modalView.visible}
          backdrop="static"
          onClose={() => setModalView({ visible: false })}
        >
          <CModalHeader>
            {!modalView.src && <CModalTitle>{strings.takePhoto}</CModalTitle>}
          </CModalHeader>
          <CModalBody style={{ textAlign: "center" }}>
            {!modalView.src ? (
              <Grid rowGap="15px">
                <Webcam
                  videoConstraints={{ facingMode }}
                  audio={false}
                  screenshotFormat="image/png"
                  width="100%"
                >
                  {({ getScreenshot }) => (
                    <Flex style={{ justifySelf: "center" }}>
                      <Button onClick={onSwitch} variation="primary">
                        <FlipCameraIos />
                      </Button>
                      <Button
                        onClick={() => {
                          const imageSrc = getScreenshot();
                          onTake(imageSrc);
                        }}
                        variation="primary"
                      >
                        <CameraAlt />
                      </Button>
                    </Flex>
                  )}
                </Webcam>
              </Grid>
            ) : (
              <img
                className="image-full"
                src={modalView.src}
                alt="gallery-img"
              />
            )}
          </CModalBody>
        </CModal>
      )}
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Galería",
    add: "Agregar",
    takePhoto: "Tomar foto",
    importPhoto: "Importar foto",
  },
});

const styles = {
  addBox: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "50px",
    height: "50px",
  },
  addIcon: {
    fontSize: "30px",
  },
};

export default Gallery;
